import React from 'react';
import { NavLink } from 'react-router-dom';

const StickyPhone = () => {
    return (
        <div className="sticky_phone">
            <NavLink to="/contact" exact className="hover" activeClassName="nav-active">
                <i class="uil uil-arrow-right"></i>
                <p>Devis gratuit</p>
                <i class="uil uil-envelope"></i>
            </NavLink>
        </div>
    );
};

export default StickyPhone;